import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import './directive'
import '@/style/index.less' // global css
// import 'ant-design-vue/dist/antd.css'
import Antd from 'ant-design-vue'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(VueClipboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
